import * as actions from './actions';

const emptyState = { loading: true, otherPropertyDeals: [] };
export default function(state = emptyState, action) {
  switch (action.type) {

  case actions.SET_RELATED_DEALS:
    return { ...action.relatedDeals };

  default:
    return state;
  }
}